export const servicesValueSet = {
  compose: {
    include: [
      {
        concept: [
          {
            code: 'S9482',
            display: 'Family stabilization services, per 15 minutes',
          },
          {
            code: 'S0221',
            display:
              'Medical conference by a physician with interdisciplinary team of health professionals or representatives of community agencies to coordinate activities of patient care (patient is present); approximately 60 minutes',
          },
          {
            code: 'T1006',
            display: 'Hospice evaluation and counseling services, pre-election',
          },
          {
            code: 'H0006',
            display: 'Alcohol and/or drug services; case management',
          },
          {
            code: 'H0025',
            display:
              'Behavioral health prevention education service (delivery of services with target population to affect knowledge, attitude and/or behavior)',
          },
          {
            code: 'H0035',
            display: 'Mental health partial hospitalization, treatment, less than 24 hours',
          },
        ],
        system: 'http://terminology.hl7.org/CodeSystem/service-type',
      },
    ],
  },
  contact: [
    {
      telecom: [
        {
          system: 'url',
          value: 'http://hl7.org/fhir',
        },
      ],
    },
  ],
  date: '2018-08-09T04:31:13+00:00',
  description: 'This value set defines subset of codes for service-types.',
  experimental: false,
  id: 'ocp-service-type',
  jurisdiction: [
    {
      coding: [
        {
          code: 'US',
          system: 'urn:iso:std:iso:3166',
        },
      ],
    },
  ],
  meta: {
    lastUpdated: '2022-08-18T18:15:56.867719+00:00',
    security: [
      {
        code: 'everyone^read',
        system: 'https://trifolia-fhir.lantanagroup.com/security',
      },
      {
        code: 'user^vMcr4CCd^write',
        system: 'https://trifolia-fhir.lantanagroup.com/security',
      },
      {
        code: 'everyone^write',
        system: 'https://trifolia-fhir.lantanagroup.com/security',
      },
      {
        code: 'user^vMcr4CCd^read',
        system: 'https://trifolia-fhir.lantanagroup.com/security',
      },
    ],
    source: '#Sfmu3ktfjyOPT82z',
    versionId: 'MTY2MDg0NjU1Njg2NzcxOTAwMA',
  },
  name: 'Service Type codes that can be used to define services performed',
  publisher: '2017-04-19T07:44:43+10:00',
  resourceType: 'ValueSet',
  status: 'draft',
  text: {
    div: '<div xmlns="http://www.w3.org/1999/xhtml">\n\t\t\t\t\t\t<h2>Supported Service Types</h2>\n\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t<p>This value set defines subset of codes of service-types.</p>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p>This value set is a subset of codes from the following code systems:</p>\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li>Include subset of the CPT codes defined in\n\t\t\t\t\t\t\t\t<a href="https://coder.aapc.com/cpt-codes/">\n\t\t\t\t\t\t\t\t\t<code>https://coder.aapc.com/cpt-codes/</code>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t<li>Include subset of the HCPCS codes defined in\n\t\t\t\t\t\t\t\t<a href="https://coder.aapc.com/hcpcs-codes/">\n\t\t\t\t\t\t\t\t\t<code>https://coder.aapc.com/hcpcs-codes/</code>\n\t\t\t\t\t\t\t\t</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t<h3>This is a subset of service types value set of CPT-4, HCPCS Codes and may be updated later.</h3>\n\t\t\t\t\t\t<table class="none">\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<b>Code</b>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<b>Display</b>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<b>S9482</b>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<i>Family stabilization services, per 15 minutes</i>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<b>S0221</b>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<i>Medical conference by a physician with interdisciplinary team of health professionals or representatives of community agencies to coordinate activities of patient care (patient is present); approximately 60 minutes</i>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<b>T1006</b>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<i>Hospice evaluation and counseling services, pre-election</i>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<b>H0006</b>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<i>Alcohol and/or drug services; case management</i>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<b>H0025</b>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<i>Behavioral health prevention education service (delivery of services with target population to affect knowledge, attitude and/or behavior)</i>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<b>H0035</b>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t\t<i>Mental health partial hospitalization, treatment, less than 24 hours</i>\n\t\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</table>\n\t\t\t\t\t</div>',
    status: 'generated',
  },
  url: 'http://www.hl7.org/fhir/us/ocp/ValueSet/service-type',
  version: '1.1.0',
};
